import React from 'react';
import Icon from '../Icon';
import svg from '../icons/status-yes-thick.js';

const IconStatusYesThick = (props) => <Icon {...props} svg={svg} />;

IconStatusYesThick.displayName = 'IconStatusYesThick';

export default IconStatusYesThick;
